import { useEffect, useRef } from "react";

export function useOutsideClick(handler) {
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(event) {
      // if ref is assigned and click is outside
      if (ref.current && !ref.current.contains(event.target)) {
        handler(event);
      }
    }

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [handler]);

  return ref;
}
